// API configuration
// In production, set REACT_APP_API_URL environment variable
// For local development, defaults to http://localhost:8000

// Detect if we're running on Render and use backend URL accordingly
const getApiBaseUrl = () => {
  // If explicitly set via environment variable, use that
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // If running on Render, try to construct backend URL
  // Render static sites and web services typically have similar URLs
  if (window.location.hostname.includes('onrender.com')) {
    // Try common Render backend URL patterns
    // You'll need to set REACT_APP_API_URL environment variable in Render
    console.warn('Running on Render but REACT_APP_API_URL not set. Please set this environment variable in Render dashboard.');
    console.warn('Expected format: https://your-backend-service.onrender.com');
  }
  
  // Default to localhost for local development
  return 'http://localhost:8000';
};

export const API_BASE_URL = getApiBaseUrl();

// Log the API URL being used (helps with debugging)
console.log('API Base URL:', API_BASE_URL);

export const RINGERS_API_URL = `${API_BASE_URL}/ringers`;
export const MUSIC_API_URL = `${API_BASE_URL}/music`;


